<!--
 * @Author: your name
 * @Date: 2020-11-20 16:07:03
 * @LastEditTime: 2020-11-20 17:26:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/contact-details/component/CheckAge/index.vue
-->
<style scoped lang="sass">
.check_age

.wrong_info
  height: 0
  color: rgba(176, 0, 32, 1)
  font-size:12px
  line-height: 14px
  margin-bottom: 15px
  overflow: hidden
  margin-top: 12px
  transition: .3s all ease

.check_box
  display: flex
  align-items: center
  height: 50px
  font-size: 12px
  color: var(--menu-primary-text-colour) !important

.text
  margin-left: 6px

.wrong_info_dispear
  height: 50px

.icon_color
  color: var(--menu-primary-background-colour) !important
</style>

<template lang="pug">
.check_age
  slot(name="age-info")
  .check_box
    van-checkbox(
      :name="name"
      :value="ageCheck"
      @click="click"
      v-on="$listeners"
    )
      template(#icon="props")
        icon.icon_color(v-if="props.checked") check_box
        icon.icon_color(v-else) check_box_outline_blank
    span.text {{ ageAskText }}
  .wrong_info(:class="{'wrong_info_dispear': wrongAge }") {{ wrongAgeText }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    name: {
      type: String
    },

    wrongAge: {
      type: Boolean
    },

    ageCheck: {
      type: String
    },

    ageAskText: {
      type: String
    },

    wrongAgeText: {
      type: String
    }
  }
})

class CheckAge extends Vue {
  click() {
    this.$emit('update:ageCheck', this.ageCheck === 'checked' ? '' : 'checked')
  }
}

export default CheckAge
</script>
